import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  tabindex: "0",
  class: "symbol focus:transform-origin-center focus:scale-110 focus:shadow-xl hover:transform-origin-center hover:scale-110 hover:shadow-xl shadow-lg transition-all duration-200 ease-in-out cursor-pointer flex flex-col h-full"
}
const _hoisted_2 = { class: "h-[200px] flex-none" }
const _hoisted_3 = ["src", "alt", "name"]
const _hoisted_4 = { class: "bg-brandGray py-2 px-4 rounded-b text-base flex flex-col h-full" }
const _hoisted_5 = { class: "text-black w-full truncate font-bold text-lg" }
const _hoisted_6 = { class: "text-brandDarkGray w-full truncate" }
const _hoisted_7 = { class: "text-brandDarkGray w-full truncate" }
const _hoisted_8 = { class: "shadow-lg" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "h-[200px] w-full bg-white animate-pulse" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "bg-brandGray py-4 px-4 rounded-b h-[68px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-black/65 rounded-full animate-pulse h-3 w-1/4" }),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-3 bg-brandDarkGray rounded-full animate-pulse h-3 w-full" })
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

import {
		Result
	} from '@/types'

	
	const __default__ = { name: "SearchResult" } 	// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		equipmentType: {
			type: String,
			default: ''
		},
		result: {
			type: Object,
			default: () => {return {} as Result}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

const props = __props;

	

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: __props.result.ImageUrl,
          alt: __props.result.ProductDisplayText,
          name: __props.equipmentType +'-image',
          class: "bg-white rounded-t object-cover h-full w-full"
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(__props.result.Product), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(__props.result.ProductSecondary), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(__props.result.Manufacturer), 1)
      ])
    ], 512), [
      [_vShow, !__props.loading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_8, _hoisted_11, 512), [
      [_vShow, __props.loading]
    ])
  ], 64))
}
}

})